import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useStateContext } from '../contexts/ContextProvider';

// Academic Admins (role 3) are school-management only — payments, invoices
// and other money views stay off-limits even via direct URL, not just hidden
// from the sidebar (see Sidebar.jsx's financeSections for the nav-side gate).
const MONEY_PATH_PREFIXES = [
  '/class-payments', '/all-payments', '/transaction-details', '/settlement-details',
  '/class-transaction', '/flexpay', '/flexpay-history', '/class-addons', '/addon-payments',
  '/financing', '/withdraw', '/transfer', '/expenses', '/expense-details',
  '/finance', '/compliance/payment',
];
const isMoneyPath = (pathname) =>
  MONEY_PATH_PREFIXES.some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`));

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = !!Cookies.get('accessToken');
  const { user } = useStateContext();
  const isAcademicAdmin = user?.role === 3;

  return (
    <Route
      {...rest}
      render={props => {
        if (!isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: "/signin",
                state: { from: props.location }
              }}
            />
          );
        }
        if (isAcademicAdmin && isMoneyPath(props.location.pathname)) {
          return <Redirect to="/" />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
